'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaderSubtitle = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _getFlagsAndNotes = require('./table/getFlagsAndNotes');

var _src = require('../../rules/src/');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getHeaderSubtitle = exports.getHeaderSubtitle = function getHeaderSubtitle(dimensions, combinations, customAttributes, display, microdataDimension) {
  var combinationsConepts = R.pipe(R.pluck('concepts'), R.unnest)(combinations);
  var DEFAULT_REJECTED_SUBTITLE_IDS = ['_L', '_T', '_Z'];

  return R.reduce(function (acc, dim) {
    if (!R.propOr(true, 'display', dim) || R.propEq('id', microdataDimension, dim) || R.includes(dim.id, combinationsConepts)) {
      return acc;
    }
    var value = R.path(['values', 0], dim);
    if (!R.propOr(true, 'display', value) || R.includes(value.id, DEFAULT_REJECTED_SUBTITLE_IDS)) {
      return acc;
    }
    var header = (0, _src.dimensionValueDisplay)(display)(dim) + ':';
    var label = (0, _src.dimensionValueDisplay)(display)(value);
    var flags = R.pipe(_getFlagsAndNotes.getFlagsAndNotes, R.map(function (entry) {
      return {
        code: entry.code,
        header: (0, _src.dimensionValueDisplay)(display)(entry) + ':',
        label: (0, _src.dimensionValueDisplay)(display)(entry.value)
      };
    }))(dim.attrValues, customAttributes);
    return R.append({ header: header, label: label, flags: flags }, acc);
  }, [], dimensions);
};